import React, { useContext, useEffect, useState } from "react";

import { BsTelephoneFill } from "react-icons/bs";
import { FaAddressBook } from "react-icons/fa";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { BsTelephone } from "react-icons/bs";
import { Context } from "../../utils/context";
import Head from "./Head";
import "./singleCustomer.css";
import { NavLink, useParams } from "react-router-dom";
import Pagination from "./Pagination";
import SortButton from "./SortButton";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
const SingleCustomer = () => {
  const {
    setHeading,
    agentData,
    setAgentData,
    setAgentCallData,
    agentCallData,
    setPage,
    setPageCount,
    page,
    sort,
  } = useContext(Context);

  const [entries, setEntries] = useState(25);
  const id = useParams().id;
  useEffect(() => {
    fetch(`http://api.realtalk.reallytics.ai/agent-performance/${id}`)
      .then(async (res) => setAgentData(await res.json()))
      .catch((e) => console.log(e));
    setHeading("Customer Analysis");
  }, [id]);
  const topics = agentData[0]?.TopTopics[0].replace(/['\[\]]/g, "").split(",");
  useEffect(() => {
    fetch(
      `http://api.realtalk.reallytics.ai/final-data/${id}/${page}?entries=${entries}&sort_by=${sort[0]}&accending=${sort[1]}`
    )
      .then(async (res) => await res.json())
      .then((res) => {
        setAgentCallData(res.data);
        setPageCount(res.pageCount);
      })
      .catch((e) => console.log(e));
  }, [id, page, sort]);
  useEffect(() => {
    fetch(
      `http://api.realtalk.reallytics.ai/final-data/${id}/1?entries=${entries}&sort_by=${sort[0]}&accending=${sort[1]}`
    )
      .then(async (res) => await res.json())
      .then((res) => {
        setAgentCallData(res.data);
        setPageCount(res.pageCount);
        setPage(1);
      })
      .catch((e) => console.log(e));
  }, [entries]);

  return (
    <>
      <div className="singleCustomer">
        <div className="customerHead">
          <div>
            <h3>{agentData[0]?.Agent_Name}</h3>
            <p>Agent</p>
          </div>
          <ul>
            <li>
              <span>
                <BsTelephoneFill />
              </span>
              <span>+92 300 1111111</span>
            </li>
            <li>
              <span>
                <FaAddressBook />
              </span>
              <span>156-T Main Street, New York, USA</span>
            </li>
          </ul>
        </div>

        <div className="customerMid">
          <div className="salesSection">
            <Head heading="Sales and Services" />

            <ul className="salesContent">
              <li>
                <span>
                  <span className="icon">
                    {" "}
                    <BsFileEarmarkBarGraph />{" "}
                  </span>
                  <span className="content">
                    <span>{topics ? topics[0] : ""}</span>
                    <span>Time . New York</span>
                  </span>
                </span>
                <span>89.80%</span>
              </li>
              <li>
                <span>
                  <span className="icon secIcon">
                    {" "}
                    <BsTelephone />{" "}
                  </span>
                  <span className="content">
                    <span>Total Calls</span>
                    <span>Time . New York</span>
                  </span>
                </span>
                <span>{agentData[0]?.Total_Calls}</span>
              </li>
            </ul>
          </div>
          <div className="chartSection">
            <Head heading="Agent Performance" key="Agent Performance" />
            <div className="chart">
              <CircularProgressbar
                value={agentData[0]?.Agent_Performance}
                text={`${agentData[0]?.Agent_Performance}%`}
              />
            </div>
          </div>
          <div className="chartSection">
            <Head heading="Customer Satisfaction" key="Customer Satisfaction" />
            <div className="chart">
              <CircularProgressbar
                value={(
                  (agentData[0]?.Customer_Satisfaction /
                    agentData[0]?.Total_Calls) *
                  100
                ).toFixed(0)}
                text={`${(
                  (agentData[0]?.Customer_Satisfaction /
                    agentData[0]?.Total_Calls) *
                  100
                ).toFixed(0)}%`}
              />
            </div>
          </div>
          <div className="topics">
            <h3>Top Topics (All Calls)</h3>
            <div className="line"></div>
            <ul>
              {topics?.map((topic, index) => {
                return <li key={index}>{topic}</li>;
              })}
            </ul>
          </div>
        </div>

        <div className="customerBottom">
          <div className="summery">
            <div className="query">
              {/* <input type="search" placeholder="search" /> */}
              <Pagination />
              <select onChange={({ target }) => setEntries(target.value)}>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <table>
              <thead>
                <tr>
                  <th>
                    Id
                    <SortButton value="TranscriptID" />
                  </th>
                  <th>
                    Anger
                    <SortButton value="Agent_Anger" />
                  </th>
                  <th>
                    Sadness
                    <SortButton value="Agent_Sadness" />
                  </th>
                  <th>
                    Excitement
                    <SortButton value="Agent_Excitement" />
                  </th>
                  <th>
                    Satisfaction
                    <SortButton value="Agent_Satisfaction" />
                  </th>
                  <th>
                    Empathy
                    <SortButton value="Agent_Empathy" />
                  </th>
                  <th>
                    Friendliness
                    <SortButton value="Agent_Friendliness" />
                  </th>
                  <th>
                    Admiration
                    <SortButton value="Agent_Admiration" />
                  </th>
                  <th>
                    Understanding
                    <SortButton value="Agent_Understanding/Anticipation" />
                  </th>
                  <th>
                    Engagement
                    <SortButton value="Agent_Engagement" />
                  </th>
                  <th>
                    Stress
                    <SortButton value="Agent_Stress" />
                  </th>
                  <th>
                    Confidence
                    <SortButton value="Agent_Confidence" />
                  </th>
                  <th>
                    Professionalism
                    <SortButton value="Agent_Professionalism" />
                  </th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {agentCallData?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.TranscriptID}</td>
                      <td>{item.Agent_Anger.toFixed(4)}</td>
                      <td>{item.Agent_Sadness.toFixed(4)}</td>
                      <td>{item.Agent_Excitement.toFixed(4)}</td>
                      <td>{item.Agent_Satisfaction.toFixed(4)}</td>
                      <td>{item.Agent_Empathy.toFixed(4)}</td>
                      <td>{item.Agent_Friendliness.toFixed(4)}</td>
                      <td>{item.Agent_Admiration.toFixed(4)}</td>
                      <td>
                        {item["Agent_Understanding/Anticipation"].toFixed(4)}
                      </td>
                      <td>{item.Agent_Engagement.toFixed(4)}</td>
                      <td>{item.Agent_Stress.toFixed(4)}</td>
                      <td>{item.Agent_Confidence.toFixed(4)}</td>
                      <td>{item.Agent_Professionalism.toFixed(4)}</td>
                      <td>
                        <NavLink to={`/customer/transcript/${item._id}`}>
                          <VisibilityIcon />
                        </NavLink>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination />
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleCustomer;
